import { all } from 'redux-saga/effects';

import config from './config/saga';
import validate from './validate/saga';
import auth from './auth/saga';
import contacts from './contacts/saga';
import contactsByCpf from './contactsByCpf/saga'
import contract from './contract/saga';
import proposal from './proposal/saga';
import agreement from './agreement/saga';
import analytic from './analytic/saga';
import negotitation from './negotiation/saga';
import addresses from './addresses/saga';

export default function* rootSaga() {
  return yield all([
    config,
    validate,
    auth,
    contacts,
    contactsByCpf,
    contract,
    proposal,
    agreement,
    analytic,
    negotitation,
    addresses,
  ]);
}
